import Link from "next/link";
import React from "react";
import { TOC } from "react-markdown-toc/client";

interface TOCClientProps {
  toc: any;
}

const TOCClient = ({ toc }: TOCClientProps) => {
  return (
    <TOC
      toc={toc}
      renderList={(children) => <ul className="pl-4">{children}</ul>}
      renderListItem={(children) => <li>{children}</li>}
      renderLink={(children, href, active) => (
        <Link
          className="text-size-xs text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400"
          data-active={active}
          href={href}
          scroll={false}
          onClick={() => {
            const element = document.querySelector(`[href*='${href}']`);
            const offset = 80;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element!.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }}
        >
          {children}
        </Link>
      )}
    />
  );
};

export default TOCClient;
